module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "player-btn",
    class: [_vm.size ? _vm.size : 'm'],
    attrs: {
      "type": "button"
    },
    on: {
      "mousedown": _vm.stopEvent,
      "click": _vm.doClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.isPlaying ? _vm.$_getIcon('icons8-pause-24.png') : _vm.$_getIcon('icons8-play-24.png')
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2d56f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/g_plugin/btn/PlayButton.vue
// module id = 1981
// module chunks = 1